function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    } r

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  //   document.querySelectorAll("product-model").forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

class UpsellAddButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onButtonClick.bind(this))
  }

  onButtonClick(event) {
    event.preventDefault();
    this.disabled = true;
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    this.querySelector('.button_text').style.opacity = 0;
    const id = event.target.getAttribute('data-variant-id');
    console.log(event.target);
    console.log(id);
    theme.addItem(id, 1);
  }
}

customElements.define("upsell-add-button", UpsellAddButton);


function debounce(fn, wait = 200) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.imgUrl = function (src, size) {
  if (src.length == 0) return;
  return src
    .replace(
      /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
      "."
    )
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
      return "_" + size + match;
    });
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    return;
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);

      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {


    /*
  const _this = this;
  setTimeout(() => {
    if(_this.mainDetailsToggle.hasAttribute('open') && !_this.mainDetailsToggle.contains(document.activeElement)) _this.closeMenuDrawer();
  },250);
  */
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };
    //     this.querySelectorAll('.anim-in').forEach(el => {
    //       el.classList.remove('inview');
    //     });

    window.requestAnimationFrame(handleAnimation);
  }
}

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

class CartDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });

  }


  buildKlaviyoBIS(e) {
    console.log('buildKlaviyoBIS');
    const productHandle = e.getAttribute('data-handle');
    const productTitle = e.getAttribute('data-title');
    const _this = this;

    if (!productHandle) return;

    fetch(`/products/${productHandle}?section_id=klaviyo-bis`)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const collectionPopupForm = document.querySelector('#PopupModal-klaviyo-bis--collection .klaviyo-bis__sizes');
        _this.doc = doc;

        const klaviyoVariantInput = document.createElement('input');
        klaviyoVariantInput.type = "hidden";
        klaviyoVariantInput.className = 'klaviyo-variant-id';
        klaviyoVariantInput.value = '';



        if (collectionPopupForm) {
          collectionPopupForm.innerHTML = doc.getElementById('shopify-section-klaviyo-bis').innerHTML;
          collectionPopupForm.appendChild(klaviyoVariantInput);
        }

        document.querySelector('.klaviyo-bis-product-title').textContent = productTitle;

        document.querySelectorAll('.bis__radio input').forEach(inpt => {
          inpt.addEventListener('change', e => {
            const variantInfo = JSON.parse(_this.doc.getElementById('bis-variants').innerHTML);
            const checked = [];
            document.querySelectorAll('.bis__radio input:checked').forEach(inpt => {
              checked.push(inpt.value);
            });
            const checkedTitle = checked.join(' / ');
            variantInfo.forEach(variant => {
              if (variant.title === checkedTitle) {
                klaviyoVariantInput.value = variant.id;
                klaviyoVariantInput.setAttribute('product-id', variant.product_id);
                return variant;
              }
            });
          });
        });

        const telephoneInputProduct = document.querySelector(".intl-tel");
        if (telephoneInputProduct) {
          window.itiProduct = intlTelInput(telephoneInputProduct, {
            initialCountry: 'US'
          });
          console.log(window.itiProduct);
        }

      });
  }



  show(opener) {
    this.openedBy = opener;
    /* if it's a collection BIS trigger */
    if (opener.classList.contains('plp-klaviyo-bis')) {
      this.buildKlaviyoBIS(opener);
    }

    /* if it's ajax content */
    if (this.hasAttribute("data-ajax-content")) {
      const _modal = this;
      const dialogAjaxContent = this.getAttribute("data-ajax-content");
      const dialogContent = this.querySelector(".modal-ajax-content");
      fetch(dialogAjaxContent)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          dialogContent.innerHTML = html;
          _modal.classList.add("loaded");


          theme.sizeGuideInit();
        })
        .catch(function (err) {
          console.warn("something went wrong.", err);
        });
    }
    document.body.classList.add("overflow-hidden");

    this.setAttribute("open", "");
    const myPopup = this.querySelector('.template-popup');
    if (myPopup) {
      myPopup.loadContent();
    }
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

window.addEventListener("load", (event) => {
  customElements.define("modal-opener", ModalOpener);
  customElements.define("modal-dialog", ModalDialog);
  customElements.define("menu-drawer", MenuDrawer);
  customElements.define("cart-drawer", CartDrawer);
  customElements.define("header-drawer", HeaderDrawer);
});

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    button.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal")).show(button);
    });
  }
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]').addEventListener(
      "click",
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

var theme = theme || {};

theme.addItem = function (v, q, p) {
  q = q || 1;
  p = p || "";
  const formData = {
    items: [
      {
        id: v,
        quantity: q
      }
    ],
  };
  if (p != '') {
    formData.items[0].properties = p;
  }
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      theme.addToCartOk(data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

theme.removeItem = function (v) {
  const formData = {
    id: v.toString(),
    quantity: 0
  };
  console.log(formData);
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      theme.updateCart(data);
    })

    .catch((error) => {
      console.error("Error:", error);
    });

};

theme.replaceElements = function (arr, data) {
  arr.forEach(function (el, i) {
    document.querySelector(el).innerHTML = data.querySelector(el).innerHTML;
  });
};

theme.updateCart = function (open = false) {
  fetch("/?section_id=cart-drawer")
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartReplacements = [".cart-drawer .cart__contents", '.cart-upsells','.cart-drawer__footer','.cart-drawer__inner'];
      theme.replaceElements(cartReplacements, doc);
      theme.checkGWP();

      theme.scrollAnimations();
      if (open) {
        theme.openCartDrawer();
      }
      initGiftWrapping();
    })
    .finally(() => {
      console.log('theme.updateCart Finally');
      theme.upsells();
      initGiftWrapping();
    })
    .catch(function (err) {
      console.warn("Something went wrong.", err);
    });
};

theme.updateURL = function (url) {
  window.history.replaceState({}, "", url);
};

theme.cartDrawerLayout = function () {
  const h = document.querySelector('.cart-drawer__header').offsetHeight;
  document.querySelector('.cart-drawer__main').style.paddingTop = h + 'px';

}

theme.openCartDrawer = function () {
  document.querySelector("body").classList.add("overflow-hidden");
  const cartDrawer = document.querySelector(".cart-drawer");
  const checkoutBtn = document.querySelector(".cart__checkout-button");
  cartDrawer.classList.add("is--open");
  cartDrawer.setAttribute("aria-hidden", false);
  cartDrawer.setAttribute("tabindex", "0");
  trapFocus(cartDrawer, checkoutBtn);
  //   theme.wearWith();
  theme.scrollAnimations();
  theme.cartDrawerLayout();
};

theme.closeCartDrawer = function () {
  document.querySelector("body").classList.remove("overflow-hidden");
  const cartDrawer = document.querySelector(".cart-drawer");
  cartDrawer.querySelectorAll('.cart-item').forEach(cartItem => {
    cartItem.classList.remove('inview');
  });
  cartDrawer.classList.remove("is--open");
  cartDrawer.setAttribute("aria-hidden", true);
  cartDrawer.setAttribute("tabindex", "-1");
};

theme.addToCartOk = function (c) {
  theme.updateCart(true);
};

theme.quickAdd = function () {
  const quickAddRadios = document.querySelectorAll(".quick-add__radio input");
  quickAddRadios.forEach((el) => {
    el.addEventListener("change", function (e) {
      e.preventDefault();
      const productCard = el.closest(".card-wrapper");
      const selected = productCard.querySelectorAll("input:checked");
      const selectedMap = Array.from(selected)
        .map((el) => el.value)
        .join(" / ");

      const json = JSON.parse(
        productCard.querySelector(".card--product").dataset.variants
      );
      const preOrderInfo = productCard.querySelector('.card--product').dataset.preOrderInfo.split(',');
      let props = {};
      const propertyInputs = productCard.querySelectorAll('.product-input__property');
      propertyInputs.forEach((input) => {
        const inputName = input.getAttribute('data-name');
        props[inputName] = input.value;
      });

      console.log(selectedMap);

      let i = 0;
      json.forEach((variant) => {
        console.log(variant.title, selectedMap);
        if (variant.title === selectedMap) {
          if (preOrderInfo[i] !== '') {
            props['Note'] = preOrderInfo[i];
            props['_narvar'] = preOrderInfo[i];
          }
          theme.addItem(variant.id, 1, props);
        }
        i++;
      });
    });
  });
};

theme.cartDrawer = function () {
  document
    .querySelector("#cart-icon-bubble")
    .addEventListener("click", function (e) {
      e.preventDefault();
      theme.openCartDrawer();
      const cartDrawerEl = document.querySelector(".cart-drawer");
    });

  document
    .querySelector(".cart-drawer__close")
    .addEventListener("click", function (e) {
      e.preventDefault();
      theme.closeCartDrawer();
    });

  document
    .querySelector(".cart-drawer .drawer__outer")
    .addEventListener("click", function (e) {
      e.preventDefault();
      theme.closeCartDrawer();
    });
};

theme.klaviyoForms = function () {
  const subscribeForms = document.querySelectorAll(".klaviyo-subscribe");
  subscribeForms.forEach((form) => {
    const button = form.querySelector(".newsletter-form__button");
    button.addEventListener("click", function (e) {
      e.preventDefault();
      theme.klaviyoSubscribe(form);
    });
  });
  const bisForms = document.querySelectorAll(".klaviyo-bis");
  bisForms.forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      theme.klaviyoSubscribe(form, function () {
        theme.klaviyoBISsubmit(form);
      });
    });
  });
};

theme.klaviyoSubscribe = function (form, callback) {

  const email = form.querySelector('input[name="email"]').value;
  const phone = form.querySelector('input[name="phone"]');
  const acceptsMarketing = true;
  const listId = form.querySelector('input[name="g"]').value;
  const successMessage = form.getAttribute("data-success-message");
  const messages = form.querySelector(".messages");
  const subscribeUrl = "//manage.kmail-lists.com/ajax/subscriptions/subscribe";
  let phoneNumber = '';


  if (email === "") {
    messages.textContent = "Please enter a valid email address";
    messages.classList.remove("hidden");
    return false;
  }

  //   const formBodyInputs = {
  //     g: listId,
  //     email: email,
  //     $consent: ["sms","email"],
  //     phone_number: false,
  //     sms_consent: acceptsMarketing
  //   }; 
  //   const formBody = new URLSearchParams(formBodyInputs);

  if (phone && phone.value != '') {
    const countryCode = form.querySelector('.iti__selected-flag').getAttribute('title').split(': ')[1];
    phoneNumber = `${countryCode}${phone.value}`;
  }

  const bodyContent = {
    g: listId,
    email: email,
    sms_consent: true,
    $fields: '$phone_number,sms_consent',
    $phone_number: phoneNumber,
    $consent: ['sms']
  };

  fetch(subscribeUrl, {
    body: new URLSearchParams(bodyContent),
    method: "POST",
  })
    .then((response) => response.json())
    .then((response) => {

      if (response.success) {
        messages.textContent = successMessage;
      } else {
        messages.textContent = response.errors;
      }
      console.log('subscribe', response);
      messages.classList.remove("hidden");
      if (callback && typeof callback === 'function') {
        callback();
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

theme.klaviyoBISsubmit = function (form) {
  const url = "//a.klaviyo.com/onsite/components/back-in-stock/subscribe";
  const email = form.querySelector(".klaviyo-bis-email").value;
  const messages = form.querySelector(".messages");
  const hiddenInfo = form.querySelector('.klaviyo-variant-id');
  var variantId = false;
  var productId = false;
  if (hiddenInfo) {
    variantId = parseFloat(hiddenInfo.value);
    productId = hiddenInfo.getAttribute('product-id');
  } else {
    variantId = window.currentVariant.id || false;
    productId = window.currentVariant.productId || false;
  }

  const formBody = new URLSearchParams({
    a: window.klaviyoAccountId,
    email: email,
    variant: variantId,
    product: productId,
    platform: "shopify"
  });
  messages.classList.add("hidden");
  if (email === "") {
    messages.textContent = "Please enter a valid email";
    messages.classList.remove("hidden");
    return false;
  }

  fetch(url, {
    body: formBody,
    method: "POST",
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        messages.textContent = "You're in! We'll let you know when it's back.";
      } else {
      }
      messages.classList.remove("hidden");
    })
    .catch((err) => {
      console.error(err);
    });
};

theme.videoOnScroll = function () {
  const videoScrollOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.8
  };
  const videoScrollCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.target.classList.contains('no-autoplay')) return true;
      if (entry.target.parentNode.classList.contains('product__media-item')) return true;
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  }
  const videoObserver = new IntersectionObserver(videoScrollCallback, videoScrollOptions);
  const videos = document.querySelectorAll('video:not(.hover-video)');
  videos.forEach(video => {
    videoObserver.observe(video);
  });
};


Array.prototype.unique = function () {
  return this.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
}

theme.getStyleAndType = function (title) {
  if (title.indexOf(window.splitValue) == -1) {
    return "";
  }
  const titleSplit = title.split(window.splitValue)[0].trim().split(" ");
  const f = titleSplit[0];
  const l = titleSplit[titleSplit.length - 1];
  const fl = `${f}+${l}`;
  return fl;
};


theme.loadScript = function (scriptUrl) {
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  document.body.appendChild(script);
  return new Promise((res, rej) => {
    script.onload = function () {
      res();
    }
    script.onerror = function () {
      rej();
    }
  });
};

theme.inToCm = function (n) {
  return theme.roundToHalf((n * 2.54).toFixed(2));
};

theme.cmToIn = function (n) {
  return Math.round(n / 2.54);
};

theme.totalColorsSearched = [];
theme.totalColors = function () {

  document.querySelectorAll(".card--product").forEach((item) => {
    const title = item.getAttribute("data-title");
    const cardInfo = item.nextElementSibling;
    if (!cardInfo) return;

    const totals = cardInfo.querySelector(".total-colors");
    if (totals) return;

    let q = theme.getStyleAndType(title);
    const qArr = q.split('+');
    const qArrBasic = theme.getStyleAndType(title);
    let total = 0;
    if(qArr[0] === 'x')return;
    const cardJson = JSON.parse(item.getAttribute('data-variants'));
    const cardTags = JSON.parse(item.getAttribute('data-tags'));

    let useFabric = false;

    const saleProduct = cardJson[0].compare_at_price > cardJson[0].price;

    if (theme.totalColorsSearched.indexOf(q) > -1) return;
    theme.totalColorsSearched.push(q);

    window.allFabrics.forEach(fabric => {
      const fabricLowercase = fabric.toLowerCase();
      if (cardTags.indexOf(fabric) > -1 || cardTags.indexOf(fabricLowercase) > -1) {
        useFabric = fabric;
        q = q + '+' + fabric;
        qArr.push(fabric);
      }
    });

    const queryUrl = `/search?q=title:${q}&type=product&view=api`;
    fetch(queryUrl)
      .then((response) => response.json())
      .then((results) => {
        results.forEach((item) => {
          if (item.title.indexOf('Extended') > -1) return;
          if (item.vendor === 'Archive') return;
          let itemQ = theme.getStyleAndType(item.title);
          if (useFabric) {
            itemQ = itemQ + '+' + useFabric;
          }
          const itemSale = item.compare_at_price > item.price;
          if (itemSale !== saleProduct) return true;
          if (item.title.indexOf(qArr[0]) == -1) return;
          if (item.title.indexOf(qArr[1]) == -1) return;
          if (useFabric && item.title.indexOf(qArr[2]) == -1) return;

          total = total + 1;
        });
        const myProducts = document.querySelectorAll(
          `div[data-style-type="${qArrBasic}"]`
        );
        const hasTotalColors = item.querySelector('.total-colors');
        if (hasTotalColors) return;
        if (total <= 1) return;
        const totalColorsEl = document.createElement("div");
        const s = total > 1 ? 's' : '';
        totalColorsEl.innerHTML = `${total} Color${s}`;
        totalColorsEl.classList.add("total-colors");
        myProducts.forEach((product) => {
          const myInfo = product.querySelector('.card__colors-wrapper');
          if (myInfo) {
            myInfo.append(totalColorsEl.cloneNode(true));
          }
        });
      });
  });
};

theme.playPauseToggle = function (vid, state) {
  const mediaId = vid.getAttribute("class");
  const buttons = document.querySelectorAll(
    `.video--toggle[data-video="${mediaId}"]`
  );
  buttons.forEach(function (button, b) {
    if (state === "playing") {
      button.classList.add("is--playing");
    } else {
      button.classList.remove("is--playing");
    }
  });
};

theme.playPauseButtons = function () {
  const videos = document.querySelectorAll("video");
  videos.forEach((video) => {
    const videoParent = video.parentNode;
    if (!videoParent.querySelector('.video--toggle')) {
      var button = document.createElement("button");
      button.setAttribute("class", "video--toggle");
      button.setAttribute("data-video", video.getAttribute("class"));
      button.innerHTML = `
        <svg class="icon-pause" role="presentation" focusable="false" aria-hidden="true" height="30" viewBox="0 0 511.448 511.448" width="30" xmlns="http://www.w3.org/2000/svg"><path d="M436.508 74.94c-99.913-99.913-261.64-99.928-361.567 0-99.913 99.913-99.928 261.64 0 361.567 99.913 99.913 261.64 99.928 361.567 0 99.912-99.912 99.927-261.639 0-361.567zM255.724 469.39c-117.816 0-213.667-95.851-213.667-213.667S137.908 42.057 255.724 42.057 469.39 137.908 469.39 255.724 373.54 469.39 255.724 469.39z"/><path d="M298.39 160.057c-11.598 0-21 9.402-21 21V330.39c0 11.598 9.402 21 21 21s21-9.402 21-21V181.057c0-11.598-9.401-21-21-21zM213.057 160.057c-11.598 0-21 9.402-21 21V330.39c0 11.598 9.402 21 21 21s21-9.402 21-21V181.057c0-11.598-9.401-21-21-21z"/></svg>
        <svg class="icon-play" role="presentation" focusable="false" aria-hidden="true" height="30" viewBox="0 0 511.449 511.449" width="30" xmlns="http://www.w3.org/2000/svg"><path d="M436.508 74.941c-99.913-99.913-261.639-99.928-361.566 0-99.914 99.912-99.93 261.64 0 361.567 99.913 99.913 261.639 99.928 361.566 0 99.913-99.912 99.929-261.64 0-361.567zm-180.784 394.45c-117.816 0-213.667-95.851-213.667-213.667S137.908 42.058 255.724 42.058s213.667 95.851 213.667 213.667-95.85 213.666-213.667 213.666z"/><path d="M332.617 239.148l-96-74.667c-13.774-10.715-33.893-.863-33.893 16.577v149.333c0 17.563 20.25 27.186 33.893 16.577l96-74.667c10.796-8.398 10.809-24.745 0-33.153zm-87.893 48.305v-63.458l40.795 31.729z"/></svg>
        <span class="visually-hidden">Play Video</span>`;
      video.parentNode.append(button);
    }

    video.addEventListener("play", function (e) {
      theme.playPauseToggle(e.target, "playing");
    });
    video.addEventListener("pause", function (e) {
      theme.playPauseToggle(e.target, "paused");
    });
  });

  const videoButtons = document.querySelectorAll(".video--toggle");
  videoButtons.forEach(function (videoButton, v) {
    videoButton.addEventListener("click", function (e) {
      var mediaId = e.target.getAttribute("data-video");
      var video = videoButton.previousElementSibling;
      if (!video) return;
      if (!video.paused) {
        video.pause();
        videoButton.classList.remove('is--playing');
        video.classList.add('force-pause');
      } else {
        videoButton.classList.add('is--playing');
        video.play();
      }
    });
  });
};

/*
theme.glideDataSetup = function() {
  document.querySelectorAll('.glide[data-options]').forEach((glide) => {
    const options = JSON.parse(JSON.stringify(glide.getAttribute('data-options')));
    // const glideEl = new Glide(glide, options);
    const glideEl = new Glide('.glide[data-options]', {
      type: 'carousel',
      focusAt: 'center',
      perView: 4
    });
    glideEl.mount();
  });
}*/

theme.toHandle = function (str) {
  if (!str) return;
  return str.toLowerCase().replace(/["']/g, "").replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
};

theme.onLazySectionLoad = function () {

  theme.playPauseButtons();
  theme.videoOnScroll();
  theme.totalColors();
  theme.quickAdd();
  theme.lazyBackgrounds();
  theme.productCardHover();

  // theme.glideDataSetup();
};

theme.lazySections = function () {
  const sectionObserver = new IntersectionObserver((entries, secObserver) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const lazySection = entry.target.dataset.sectionId;
        const currentNode = document.querySelector(
          `#shopify-section-${lazySection}`
        );
        fetch(`/pages/sections?section_id=${lazySection}`)
          .then((response) => response.text())
          .then(function (html) {
            currentNode.outerHTML = html;
            const newNode = document.querySelector(
              `#shopify-section-${lazySection}`
            );
            newNode.style.opacity = 0;
            newNode.classList.add("lazyfade");
            theme.scrollAnimations();
            setTimeout(function () {
              newNode.classList.add("lazyloaded");
              theme.onLazySectionLoad();
            }, 0);
          });
      }
    });
  });
  const arr = document.querySelectorAll(".lazy-section");
  arr.forEach((v) => {
    sectionObserver.observe(v);
  });
};

theme.setCookie = function (name, value, exp) {
  document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * exp};`;
};

theme.getCookie = function (cName) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split('; ');
  let res = false;
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  })
  return res
};

theme.removeCookie = function (name) {
  document.cookie = `${name}=; path=/; max-age=0;`;
};

theme.checkCountry = function () {
  const country = theme.getCookie("GlobalE_Data") || false;
  if (!country) return;
  const countryJSON = JSON.parse(country);
  if (countryJSON.countryISO != 'US') {
    document.querySelectorAll('.show-international').forEach(el => {
      el.style.display = 'block';
    });
    document.querySelectorAll('.hide-international').forEach(el => {
      el.style.display = 'none';
    });
  }
};

theme.productCardHover = function () {
  const productCards = document.querySelectorAll(".card-wrapper");
  productCards.forEach((card) => {
    const cardVideo = card.querySelector("video");
    if (!cardVideo) return;
    if (card.classList.contains("card-wrapper--featured-video")) return;

    card.addEventListener("mouseover", (event) => {
      const thisCard = event.target.closest('.card-wrapper');
      const video = thisCard.querySelector('video');
      const forcePaused = video.classList.contains("force-pause");
      const form = thisCard.querySelector('form');
      if (forcePaused) return;
      if (cardVideo) {
        cardVideo.play();
      }
    });

    card.addEventListener("mouseout", (event) => {
      if (cardVideo && cardVideo.playing) {
        cardVideo.pause();
      }
    });
  });
};

theme.fetchReplaceHTML = function (url, elements) {
  if (elements.length == 0) return;
  fetch(url)
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      elements.forEach((el) => {
        const currentEl = document.querySelector(el);
        const newEl = doc.querySelector(el);
        if (currentEl && newEl) {
          document.querySelector(el).innerHTML =
            doc.querySelector(el).innerHTML;
        }
      });
    })
    .catch(function (err) {
      console.warn("something went wrong.", err);
    });
};

theme.slideUp = (target, duration = 500) => {
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(function () {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

theme.slideDown = (target, duration = 500) => {
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  target.style.removeProperty("padding-top");
  target.style.removeProperty("padding-bottom");
  target.style.removeProperty("margin-top");
  target.style.removeProperty("margin-bottom");
  window.setTimeout(function () {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

theme.slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === "none") {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
};

theme.isMobile = () => {
  return window.innerWidth < 750;
};

theme.mainNavHovers = () => {
  return;
  const headerHasMega = document.querySelectorAll('details.has-mega');
  headerHasMega.forEach((el) => {
    el.addEventListener('mouseover', function (e) {
      el.querySelector('summary').click();
    });
    el.addEventListener('mouseleave', function (e) {
      el.parentNode.removeAttribute('open');
    });
    el.addEventListener('click', function (e) {
      e.preventDefault();
      el.parentNode.setAttribute('open');
    });
  });
};


document.addEventListener("DOMContentLoaded", function () {
  theme.klaviyoForms();
  theme.quickAdd();
  theme.cartDrawer();
  theme.videoOnScroll();
  theme.totalColors();
  theme.lazySections();
  theme.playPauseButtons();
  theme.productCardHover();
  theme.lazyImages();
  theme.lazyBackgrounds();
  theme.lazyIframes();
  theme.findOverflowElements();
  theme.mainNavHovers();

});

document.addEventListener("shopify:section:load", function () {
  theme.klaviyoForms();
  theme.quickAdd();
  theme.cartDrawer();
  theme.videoOnScroll();
  theme.totalColors();
  theme.lazySections();
  theme.playPauseButtons();
  theme.lazyImages();
  theme.lazyBackgrounds();
  theme.lazyIframes();
  theme.mainNavHovers();
});

// document.querySelectorAll(".chat-with-expert").forEach((chatLink) => {
//   chatLink.addEventListener("click", function () {
//     zE("webWidget", "popout");
//   });
// });

theme.lazyImages = () => {
  if ("loading" in HTMLImageElement.prototype) {
    var lazyImages = document.querySelectorAll(".lazyImage img");

    for (var img of lazyImages) {
      if (!img.complete) {
        img.parentNode.classList.add("lazyImageWaiting");
        img.addEventListener("load", lazyImageLoad, false);
        img.addEventListener("error", lazyImageError, false);
      }
    }


    function lazyImageLoad(e) {
      const parent = e.currentTarget.parentNode;
      setTimeout(function () {
        parent.classList.remove("lazyImageWaiting");
      }, 100);
    }

    function lazyImageError(e) {
      var parent = e.currentTarget.parentNode;
      parent.classList.remove("lazyImageWaiting");
      parent.classList.add("lazyImageError");
      setTimeout(function () {
        parent.classList.add("lazyImageErrorShow");
      }, 60);
    }
  } // if 'loading' supported
};

theme.lazyBackgrounds = () => {
  var lazyBackgrounds = document.querySelectorAll('.lazyBg');

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const bgImage = entry.target.getAttribute('data-bg');
          entry.target.style.backgroundImage = `url('${bgImage}')`;
          setTimeout(function () {
            entry.target.classList.add("loaded");
          }, 250);

          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach((lazyBackground) => {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
}

theme.lazyIframes = () => {
  var lazyIframes = document.querySelectorAll('.lazyIframe');

  if ("IntersectionObserver" in window) {
    let lazyIframeObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const iframeSrc = entry.target.getAttribute('data-src');
          entry.target.setAttribute('src', iframeSrc);
          entry.target.classList.add("loaded");

          lazyIframeObserver.unobserve(entry.target);
        }
      });
    });

    lazyIframes.forEach((lazyIframe) => {
      lazyIframeObserver.observe(lazyIframe);
    });
  }
}

//I'm using "click" but it works with any event

theme.findOverflowElements = () => {
  const docWidth = document.documentElement.offsetWidth;
  [].forEach.call(document.querySelectorAll("*"), function (el) {
    if (el.offsetWidth > docWidth) {
      console.log(el);
    }
  });
};

theme.extendedSizes = () => { };

theme.tryWithAttempts = 0;

theme.wearWith = function (anyStyle = false) {
  var cts = document.querySelector('.cts--cart');
  if (!cts) return;
  var matchTitle = cts.getAttribute('data-to-match');
  if (matchTitle.indexOf(' - ') === -1) return;

  const colorSplit = matchTitle.split(' - ');
  const title = colorSplit[0].split(' ');
  const matchQuery = [];
  const topBottom = title.slice(-1).pop();
  let match = false;

  cts.style.display = 'none';


  if (topBottom == 'Top') {
    match = 'Bottom';
  } else if (topBottom == 'Bottom') {
    match = 'Top';
  } else {
  }

  if (!anyStyle) matchQuery.push(title[0]);

  if (match) matchQuery.push(match);
  matchQuery.push(colorSplit[1].replace(' ', '+'));

  var url = `/search?q=${matchQuery.join('+')}&type=product&view=wear-with`;


  if (theme.tryWithAttempts > 2) return false;

  fetch(url)
    .then(response => {
      return response.text();
    }).then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCts = doc.querySelectorAll('.cart-item');
      if (newCts.length >= 1) {
        cts.innerHTML = html;
        cts.style.display = 'block';
        theme.quickAdd();
        setInterval(function () {
          document.querySelectorAll('.cts--cart .cart-item').forEach(newCt => {
            newCt.classList.add('inview');
          });
        }, 250);

      } else {
        console.log('try again');
        theme.tryWithAttempts++;
        theme.wearWith(true);
      }
    });
};


theme.accessibe = function () {
  const acsbTrigger = document.querySelector('.acsb-custom-trigger');
  if (!acsbTrigger) return;
  acsbTrigger.addEventListener('mouseover', function (e) {
    if (typeof acsbJS === 'function') return;

    var s = document.createElement('script'),
      e = !document.body ? document.querySelector('head') : document.body;
    s.src = '//acsbapp.com/apps/app/dist/js/app.js';
    s.async = true;
    s.onload = function () {
      acsbJS.init({
        statementLink: '',
        footerHtml: '',
        hideMobile: true,
        hideTrigger: true,
        language: 'en',
        position: 'left',
        leadColor: '#146ff8',
        triggerColor: '#146ff8',
        triggerRadius: '50%',
        triggerPositionX: 'right',
        triggerPositionY: 'bottom',
        triggerIcon: 'people',
        triggerSize: 'medium',
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: 'small',
          triggerPositionX: 'right',
          triggerPositionY: 'center',
          triggerOffsetX: 10,
          triggerOffsetY: 0,
          triggerRadius: '50%'
        }
      });
    };
    e.appendChild(s);
  });
  acsbTrigger.addEventListener('click', function (e) {
    if (typeof acsbJS === 'function') {
    }
  });


};
theme.chat = function () {
  // Intercom('show');

  document.querySelectorAll('[data-open-chat]').forEach(function (chatLink) {
    chatLink.addEventListener('mouseover', function (e) {

      var w = window;
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/uziif4cw';
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    });
    chatLink.addEventListener('click', function (e) {
      e.preventDefault();
      Intercom('show');
    });
  });

  /*
  var script = document.createElement('script');
  script.src="//static.zdassets.com/ekr/snippet.js?key=0b22e572-597c-4f6f-a827-1589383ff9d3";
  script.async = true;
  script.setAttribute('id','ze-snippet');
  script.onload = function () {
    //do stuff with the script
    var waitForZopim = setInterval(function () {
      if (window.$zopim === undefined || window.$zopim.livechat === undefined) {
        return;
      }
      $zopim(function() {
        $zopim.livechat.hideAll();
      });
      
      clearInterval(waitForZopim);
    }, 1000);
  };
  document.head.appendChild(script);
  */
};

theme.scrollAnimations = function () {
  let observedElements = document.querySelectorAll('.anim-in'); // Define the elements you want to intiate an action on
  const options = { //define your options
    threshold: 0.1
  }
  const inViewCallback = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { // define the event/property you want to use
        //do something with the element, in our case, add a class 
        entry.target.classList.add('inview');
      } else {
        // entry.target.classList.remove('inview');
        // OPTIONAL, in case you want to do something once the intersection is done
      }
    });
  }
  // create a new instance using our callback which contains our elements and actions, using the options we defined
  let observer = new IntersectionObserver(inViewCallback, options);

  observedElements.forEach(element => {
    element.classList.add('animated');
    let dataDelay = element.getAttribute('data-delay') || 0;
    element.style.transitionDelay = dataDelay + 'ms';
    observer.observe(element) // run the observer 
  });
}

theme.megaHoverToClick = function () {
  document.querySelectorAll('details.has-mega,details.has-dropdown').forEach(hasMega => {
    hasMega.addEventListener('mouseenter', e => {
      e.target.setAttribute('open', '');
    });
    hasMega.addEventListener('mouseleave', e => {
      e.target.removeAttribute('open');
    });
    document.querySelectorAll('summary.header__menu-item').forEach(summary => {
      summary.addEventListener('click', e => {
        summary.parentNode.setAttribute('open','');
        window.location.href = summary.getAttribute('data-url');
      });
    });
  })
};

document.addEventListener('DOMContentLoaded', (event) => {
  theme.checkCountry();
  theme.fitVids();
  theme.scrollAnimations();
  theme.megaHoverToClick();
  theme.automateBadges();
});

theme.automateBadges = function () {

};

theme.fitVids = function () {
  var selectors = [
    'iframe[src*="player.vimeo.com"]',
    'iframe[src*="youtube.com"]',
    'iframe[src*="youtube-nocookie.com"]',
    'iframe[src*="kickstarter.com"][src*="video.html"]',
    'object',
    'embed'
  ];
  document.querySelectorAll(selectors.join(',')).forEach((iframe) => {
    const parent = iframe.parentNode;
    if (parent.classList.contains('media')) return;

    const src = iframe.getAttribute('src');
    const wrapper = document.createElement('div');

    wrapper.classList.add('media', 'media--16-9');
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);

  });
};

theme.roundToHalf = function (val) {
  var converted = parseFloat(val); // Make sure we have a number
  var decimal = (converted - parseInt(converted, 10));
  decimal = Math.round(decimal * 10);
  if (decimal == 5) { return (parseInt(converted, 10) + 0.5); }
  if ((decimal < 3) || (decimal > 7)) {
    return Math.round(converted);
  } else {
    return (parseInt(converted, 10) + 0.5);
  }
};

theme.gwpInCart = function () {
  let inCart = false;
  const cartItems = document.getElementById('main-cart-items').getAttribute('data-cart-items').split(',');
  if (cartItems.length == 0) return;
  cartItems.forEach((item) => {
    if (item != '') {
      const itemFloat = parseFloat(item);
      if (itemFloat === window.gwp.variantId) {
        inCart = true;
      }
    }
  });
  console.log('gwpInCart', inCart);
  return inCart;
}

theme.checkGWP = function () {
  if (!window.gwp.enabled) return false;

  const country = theme.getCookie("GlobalE_Data") || false;
  const countryJSON = JSON.parse(country);

  const noGwpCountries = ['ES', 'PE', 'MX', 'IT', 'AR', 'CL', 'DZ', 'ID', 'MY', 'TR', 'UY', 'VE', 'VN'];

  if (noGwpCountries.indexOf(countryJSON.countryISO) > -1) return false

  const cartTotal = parseFloat(document.getElementById('main-cart-items').getAttribute('data-cart-total'));
  const gwpSetup = {
    cartTotal: cartTotal,
    cartMin: window.gwp.minimum,
    gwpInCart: theme.gwpInCart()
  };

  if (cartTotal >= window.gwp.minimum && theme.gwpInCart() !== true) {
    theme.addGWP();
  }
  if (cartTotal < window.gwp.minimum && theme.gwpInCart() === true) {
    theme.removeGWP();
  }

}

theme.addGWP = function () {
  console.log('Add GWP!');
  const formData = {
    items: [
      {
        id: window.gwp.variantId,
        quantity: 1
      }
    ],
    sections: 'cart-drawer'
  };
  fetch("/cart/add.js", {
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    headers: {
      "Content-Type": "application/json",
      'X-Requested-With': 'xmlhttprequest'
    },
    method: "POST"
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log(data);
      const parsedState = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      document.querySelector('.cart__contents').innerHTML = parsedState.querySelector('.cart__contents').innerHTML;
      theme.cartDrawerLayout();
      theme.scrollAnimations();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  //   theme.addItem(window.gwp.variantId,1,props);
}

theme.removeGWP = function () {
  console.log('Remove GWP...');
  const formData = {
    id: window.gwp.variantId.toString(),
    quantity: 0,
    sections: 'cart-drawer'
  };
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log(data);
      const parsedState = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      document.querySelector('.cart__contents').innerHTML = parsedState.querySelector('.cart__contents').innerHTML;
      theme.cartDrawerLayout();
      theme.scrollAnimations();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  //   theme.removeItem(window.gwp.variantId);
}

theme.upsells = function () {

  const upsellCarousel = document.querySelector('.cart-upsells__carousel');
  if (!upsellCarousel) return;

  var upsellGlide = new Glide('.cart-upsells__carousel', {
    type: 'slider',
    startAt: 0,
    gap: 10,
    perView: 3,
    peek: {
      before: 0,
      after: 0
    },
    breakpoints: {
      749: {
        perView: 2
      }
    }
  });

  upsellGlide.on(['build.after'], function () {
    document.querySelectorAll('.cart-upsells__carousel .cart-item').forEach((item) => {
      item.classList.remove('animated');
    });
    theme.scrollAnimations();
    theme.quickAdd();
  });

  upsellGlide.mount();

  const upsellButtons = document.querySelectorAll('.cart-item__upsell-add');
  upsellButtons.forEach(upsellButton => {
    upsellButton.addEventListener('click', e => {
      e.preventDefault();
      theme.addItem(e.target.getAttribute('data-variant-id'), 1);
      return false;

    });
  });

};


const giftWrapId = 40413294624837;

const addGiftWrap = () => {
  theme.addItem(giftWrapId, 1);
};

const removeGiftWrap = () => {
  theme.removeItem(giftWrapId);
  const body = JSON.stringify({ note: '' });
  fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
};

const initGiftWrapping = () => {
  console.log('initGiftWrapping()');
  const cartNote = document.querySelector('.cart-note__message');
  const checkbox = document.querySelector('#gift-wrapping-checkbox');
  if(checkbox) {
    checkbox.addEventListener('change', e => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (e.target.checked) {
        addGiftWrap();
      } else {
        removeGiftWrap();
      }
    });
  }

  if(cartNote) {
    console.log('cartnote');
    cartNote.addEventListener('keyup', debounce((e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      console.log('cartnote on change: ', e.target.value);
      const body = JSON.stringify({ note: e.target.value });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    },300));
  }

};

const setEqualHeight = (elements) => {
  let maxHeight = 0;
  console.log(elements);
  // Loop through all the elements and find the tallest one
  for (let i = 0; i < elements.length; i++) {
    let elementHeight = elements[i].offsetHeight;
    if(elementHeight > maxHeight) {
      maxHeight = Math.max(maxHeight, elementHeight);  
    }
  }
  
  // Set the height of all elements to the height of the tallest element
  for (let i = 0; i < elements.length; i++) {
    elements[i].style.height = maxHeight + "px";
  }
}

const checkGDPR = () => {
  let countryCode = false;
  if(theme.getCookie('gdpr_country') === false || theme.getCookie('gdpr_accept') === false) {
    fetch('//api.ipdata.co/?api-key=4e12bbde0aafccb23d3f955251eaf17668614f4d41ee85ee8024b12e')
      .then(response => response.json())
      .then(data => {
        theme.setCookie('gdpr_country', data.country_code, 365);
        if(data.country_code !== 'US') {
          countryCode = data.country_code;
          document.querySelector('.gdpr-banner').classList.remove('hidden');
        }
      }
    );
  }
  const gdprAccept = document.querySelector('.gdpr-accept');
  const gdprClose = document.querySelector('.gdpr-close'); 

  gdprAccept.addEventListener('click', () => {
    console.log('gdprAccepted');
    theme.setCookie('gdpr_accept', true, 365);
    document.querySelector('.gdpr-banner').classList.add('hidden');
  });

  gdprClose.addEventListener('click', () => {
    console.log('gdprClosed');
    document.querySelector('.gdpr-banner').classList.add('hidden');
  });
}

window.addEventListener('load', (event) => {
  let elems = document.querySelectorAll("[onclick]");
  if (elems) {
    for (let i = 0; i < elems.length; i++) {
      let content = elems[i].getAttribute("onclick");
      elems[i].setAttribute("onkeydown", content);
    }
  }

  elems = document.getElementsByTagName("IFRAME");
  if (elems) {
    for (let i = 0; i < elems.length; i++) {
      elems[i].setAttribute("title", "Video Player");
    }
  }

  //global-e
  if (typeof GEP == "undefined") {
    var toDisplay = document.querySelectorAll(
      "[globale-product-price],[globale-order-details-price],[globale-order-list-price]"
    );
    toDisplay.forEach(function (i) {
      i.style.visibility = "visible";
    });
  }
  theme.chat();
  theme.accessibe();
  theme.checkGWP();
  theme.upsells();
  initGiftWrapping();
  // checkGDPR();

});


class CurrencyPicker extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button.localization-button'),
      panel: this.querySelector('#PopupCountryList'),
      submit: this.querySelector('button[type="submit"]')
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    // this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    this.elements.submit.addEventListener('click', this.submitForm.bind(this)); 
    
  }

  submitForm(event) {
    event.preventDefault();
    this.querySelector('form')?.submit();
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.target.dataset.value;
    this.elements.button.querySelector('span').textContent = event.target.textContent;
    this.closeSelector(event);
    
    // this.querySelector('form')?.submit();
  }

  openSelector(event) {
    event.target.focus();
    this.elements.button.setAttribute('aria-expanded', 'true');
    this.elements.panel.removeAttribute('hidden');
  }

  closeSelector(event) {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }
}

customElements.define('currency-picker', CurrencyPicker);

class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    )
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

customElements.define('product-modal', ProductModal);